const state = {};

const actions = {
  async addToShoppingCart({ commit, rootState }, args) {
    const payload = {
      products: args.productsToAddToCart.map((x) => ({
        product_code: x.productCode,
        quantity: x.quantity
      }))
    };

    const config = {
      params: {
        action: 'add_to_shopping_cart',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('webshop/setShoppingCart', data, { root: true });
    return mapProductData(data);
  },
  async getSpareParts({ rootState }, args) {
    const payload = {
      serial_number: args.serialNumber
    };

    if (args?.productCode) {
      payload.spare_parts = args.productsToAddToCart.map((x) => ({
        product_code: x.productCode,
        quantity: x.quantity
      }));
      const existing = payload.spare_parts.find(
        (x) => x.product_code === args.productCode
      );
      if (existing) {
        existing.quantity = args.quantity;
      } else {
        payload.spare_parts.push({
          product_code: args.productCode,
          quantity: args.quantity
        });
      }
    }

    const config = {
      params: {
        action: 'get_spare_parts',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    if (data.message) {
      return {
        messages: [
          {
            message: data.message,
            severity: data.sevirity
          }
        ]
      };
    }
    return mapProductData(data);
  }
};

function mapProductData(productData) {
  const spareParts = productData.spare_parts ?? [];
  return {
    serialNumber: productData.serial_number,
    productCode: productData.product_code,
    productDescription: productData.product_description,
    price: productData.price,
    customerSalesProductCode: productData.customer_sales_product_code,
    spareParts: spareParts.map((x) => ({
      customerSalesProductCode: x.customer_sales_product_code,
      productCode: x.product_code,
      productDescription: x.product_description,
      productName: x.product_description,
      sparePartsQuantity: x.spare_parts_quantity,
      quantity: x.quantity,
      priceEach: x.price_each,
      discount: x.discount,
      subtotal: x.subtotal,
      sparePartReference: x.spare_part_reference,
      delivery: x.delivery ?? {}
    })),
    messages: productData.messages.map((x) => ({
      message: x.message,
      serverity: x.serverity
    }))
  };
}

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
